<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title>Aiming High Teacher Network</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-grid>
    <ion-row class="ion-align-items-center">
      <ion-col
        *ngFor="let p of pages"
        [routerLink]="[p.url]"
        class="ion-justify-content-center ion-align-items-center"
        [attr.size-lg]="p.sizeLg"
        [attr.size-md]="p.sizeMd"
        size-xl="2"
      >
        <ion-card class="page-card ion-padding">
          <div class="square">
            <div class="content">
              <div>
                <ion-icon class="page-card-icon" [src]="p.icon"></ion-icon>
              </div>
              <div class="page-card-title">{{ p.title }}</div>
            </div>
          </div>
        </ion-card>
      </ion-col>
    </ion-row>
  </ion-grid>
  <div id="version">
    <span>v{{ VERSION }}</span>
    <span>{{ stagingSite ? " - preview" : null }}</span>
  </div>
</ion-content>
